define('shared/util/dispatchers/retrievers/omniture',['shared/lib/RSVP'], function( RSVP ){
    'use strict';

    var g = window;

    return function getOmnitureProp( key, options ) {
        return new RSVP.Promise(function(resolve, reject){
            (function loop(){
                if ( g.s && g.s[ key ]) {
                    resolve( g.s[ key ] );
                    return;
                }
                else if(options.allowUndefined){
                    resolve('');
                    return;
                }

                setTimeout(loop, 200);
            })();
        });
    };
});
